const middleware = {}

middleware['premiumOnly'] = require('../../middleware/premiumOnly.js')
middleware['premiumOnly'] = middleware['premiumOnly'].default || middleware['premiumOnly']

export default middleware
